import { render, staticRenderFns } from "./gift_card.vue?vue&type=template&id=59827a5a&"
import script from "./gift_card.vue?vue&type=script&lang=js&"
export * from "./gift_card.vue?vue&type=script&lang=js&"
import style0 from "./gift_card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59827a5a')) {
      api.createRecord('59827a5a', component.options)
    } else {
      api.reload('59827a5a', component.options)
    }
    module.hot.accept("./gift_card.vue?vue&type=template&id=59827a5a&", function () {
      api.rerender('59827a5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/pages/info/gift_card.vue"
export default component.exports